import React, { useState, useEffect } from "react";
import numberthree from "../../Images/numberthree.png";
import "../../HoverableDivs.css"; // Import the CSS file
import { useHistory } from "react-router-dom";
import { Popover } from "antd";
import { useTranslation } from "react-i18next";
export default function Brands() {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const handleDivClick = (CategoryName) => {
    history.push(`/${CategoryName}`); // Navigate to the root path
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // Update the screen width when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Add event listener to handle resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [hoverIndex, setHoverIndex] = useState(null); // Track which div is hovered
  const [openPopovers, setOpenPopovers] = useState([
    false,
    false,
    false,
    false,
    false,
  ]); // Track the open state for each popover

  const handleMouseEnter = (index) => {
    setHoverIndex(index);
  };

  const handleMouseLeave = () => {
    setHoverIndex(null);
  };

  const handleOpenChange = (newOpen, index) => {
    const newOpenPopovers = [...openPopovers];
    newOpenPopovers[index] = newOpen;
    setOpenPopovers(newOpenPopovers);
  };

  const getItemStyle = (index) => ({
    //backgroundColor: hoverIndex === index ? "#b3d9ff" : "white", // Change color on hover
    cursor: "pointer", // Optional: change cursor to pointer on hover
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: "50%",
  });

  const names = ["L'Oréal Paris", "Garnier", "Maybelline New York"]; // Corresponding list of names
  const GoTo = ["Loreal", "Garnier", "Maybelline-New-York"]; // Corresponding list of names

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: 15,
          paddingBottom: 15,
        }}
      >
        {/* <p style={{ fontSize: 25, fontWeight: "500" }}>Owr brands</p> */}
      </div>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          //backgroundColor: "#fecdd3",
          justifyContent: "space-around",
          overflowX: "auto", // Enables horizontal scrolling
          whiteSpace: "nowrap", // Prevents wrapping to the next line
        }}
      >
        {[1, 2, 3].map((item, index) => (
          <div
            style={getItemStyle(index)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            onClick={() => {
              handleDivClick(GoTo[index]);
              // Handle click if needed
            }}
          >
            <img
              src={numberthree}
              alt="logo"
              style={{
                minWidth: "80px", // Adjust the size
                height: "80px", // Adjust the size
                borderRadius: "50%", // Makes the image circular
                objectFit: "cover", // Ensures the image covers the circle without stretching
                border: "1px solid #ccc", // Optional: Adds a border
              }}
            />
            {names[index]}
          </div>
        ))}
      </div>
    </div>
  );
}
